import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API } from '../../ApiNames';


export const fetchDataSuccess = (remove: any) => ({
    type: 'FETCH_Remove_SUCCESS',
    payload: remove,
});


export const removeData = (CaseID:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:2,caseid:CaseID};
            const apiname = Admin_API.Cases_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
